import { Modal, Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { ShowType } from '@/types/account';
import { useEffect, useState } from 'react';
import { UnstakeInfo } from '../unstakeInfo';
import styles from './index.module.less';
import { Choose } from './choose';

interface Props {
  showModal: boolean;
  setShowModal: (v: boolean) => void;
}

export const RedeemChooseModal = (props: Props) => {
  const { showModal, setShowModal } = props;
  const fm = useFm();
  const [choice, setChoice] = useState(ShowType.DelayUnStake);
  const [showType, setShowType] = useState(ShowType.Choose);
  const [visible, setVisible] = useState(true);

  const handleClick = () => {
    setShowType(choice);
  };
  const handleArrowBack = () => {
    let finalShowType = ShowType.Choose;
    if (showType === ShowType.ConfimDelayUnStake) {
      finalShowType = ShowType.DelayUnStake;
    }
    if (showType === ShowType.ConfirmUnstake) {
      finalShowType = ShowType.Unstake;
    }

    setShowType(finalShowType);
  };

  const title = () => {
    if (
      showType === ShowType.DelayUnStake ||
      showType === ShowType.ConfimDelayUnStake
    ) {
      return fm('delayRedemption');
    }
    if (showType === ShowType.Unstake || ShowType.ConfirmUnstake) {
      return fm('immediateRedemptio');
    }
    return fm('pickRedemptionMethod');
  };

  useEffect(() => {
    // 结果页时，需要隐藏底部弹窗
    if (showType === ShowType.Result) {
      setVisible(false);
    }
  }, [showType]);

  return (
    <Modal
      open={showModal}
      arrowEnable={showType !== ShowType.Choose}
      arrowHandler={handleArrowBack}
      title={title()}
      footer={null}
      modal={false}
      className={visible ? '' : styles.hidden}
      onClose={() => {
        setVisible(true);
        setChoice(ShowType.DelayUnStake);
        setShowType(ShowType.Choose);
        setShowModal(false);
      }}
    >
      {/* 选择赎回方式 */}
      {showType === ShowType.Choose && (
        <>
          <Choose choice={choice} setChoice={setChoice} />
          <Button
            variant="primary"
            size="large"
            className={styles.button}
            onClick={handleClick}
          >
            {fm('confirm1')}
          </Button>
        </>
      )}
      {/* 解质押功能 */}
      {showType !== ShowType.Choose && (
        <UnstakeInfo onChangeShowType={setShowType} showType={showType} />
      )}
    </Modal>
  );
};
